<template>
	<el-select v-model="itemChecked" :multiple="selectConfig.multiple" :loading="loading" :clearable="selectConfig.clearable" :collapse-tags="selectConfig.collapseTags" @visible-change="visible_change" @change="changeSelected" style="width: 320px;">
		<el-option v-for="item in industry" :key="item.value" :label="item.label" :value="item.value"></el-option>
	</el-select>
</template>

<script>
export default {
	name: 'select-industry',
	props: {
		multiple: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		clearable: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		collapseTags: {
			type: Boolean,
			default: () => {
				return true;
			}
		},
		multipleLimit: {
			type: Number,
			default: () => {
				return 0;
			}
		},
		placeholder: {
			type: String,
			default: () => {
				return '请选择行业';
			}
		},
		loadingText: {
			type: String,
			default: () => {
				return '正在获取……';
			}
		},
		noDataText: {
			type: String,
			default: () => {
				return '无数据';
			}
		},
		selected: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {
			loading: true,
			selectConfig: {},
			industry: [],
			itemChecked: ""
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted() {
		this.selectConfig = {
			multiple: this.multiple,
			clearable: this.clearable,
			collapseTags: this.collapseTags,
			multipleLimit: this.multipleLimit,
			placeholder: this.placeholder,
			loadingText: this.loadingText,
			noDataText: this.noDataText
		};
		this.itemChecked = Object.assign([], this.selected);
	},
	updated: function() {},
	methods: {
		visible_change(e) {
			if (e) {
				this.get_infos_industry();
			}
		},
		changeSelected(e) {
			this.$emit("change",e);
		},
		get_infos_industry() {
			if (this.industry.length < 1) {
				this.loading = true;
				this.$http.post('/server/index.php?m=components/selectIndustry&a=getInfoList', {}).then(
					res => {
						this.loading = false;
						if (res.result == 'ok') {
							this.industry = res.data;
						} else {
							this.$alert(res.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					},
					r => {
						this.loading = false;
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				);
			}
		}
	},
	watch: {
		selected: function(val) {
			this.itemChecked = Object.assign([], val);
		}
	}
};
</script>

<style></style>
